import { apiRequest } from "./client";

export const planBillingApi = {
  listPlans() {
    return apiRequest("/plan-billing/plans");
  },

  getProject(projectId) {
    return apiRequest(`/plan-billing/projects/${projectId}`);
  },

  subscribe(projectId, payload) {
    return apiRequest(`/plan-billing/projects/${projectId}/subscribe`, {
      method: "POST",
      body: payload,
    });
  },

  updatePaymentMethod(projectId) {
    return apiRequest(`/plan-billing/projects/${projectId}/payment-method`, {
      method: "POST",
      body: {},
    });
  },

  refresh(projectId) {
    return apiRequest(`/plan-billing/projects/${projectId}/refresh`, {
      method: "POST",
      body: {},
    });
  },

  pause(projectId) {
    return apiRequest(`/plan-billing/projects/${projectId}/pause`, {
      method: "POST",
      body: {},
    });
  },

  resume(projectId) {
    return apiRequest(`/plan-billing/projects/${projectId}/resume`, {
      method: "POST",
      body: {},
    });
  },

  cancel(projectId) {
    return apiRequest(`/plan-billing/projects/${projectId}/cancel`, {
      method: "POST",
      body: {},
    });
  },

  adminOverview() {
    return apiRequest("/plan-billing/admin/overview");
  },

  updatePlan(planCode, payload) {
    return apiRequest(`/plan-billing/admin/plans/${planCode}`, {
      method: "PATCH",
      body: payload,
    });
  },

  updateProject(projectId, payload) {
    return apiRequest(`/plan-billing/admin/projects/${projectId}`, {
      method: "PATCH",
      body: payload,
    });
  },
};
